import { Navigate, NavLink, Outlet, Link, useNavigate } from "react-router-dom";
import { LayoutDashboard, ShoppingBag, Inbox, BadgeEuro, Star, Image, Settings, LogOut, ExternalLink, Loader2, Signal } from "lucide-react";
import { useAuth } from "../../contexts/AuthContext";

const TABS = [
  { to: "/admin", label: "Tableau", icon: LayoutDashboard, end: true },
  { to: "/admin/produits", label: "Produits", icon: ShoppingBag },
  { to: "/admin/demandes", label: "Demandes", icon: Inbox },
  { to: "/admin/tarifs", label: "Tarifs", icon: BadgeEuro },
  { to: "/admin/forfaits", label: "Forfaits", icon: Signal },
  { to: "/admin/avis", label: "Avis", icon: Star },
  { to: "/admin/galerie", label: "Galerie", icon: Image },
  { to: "/admin/reglages", label: "Réglages", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FAFAFA]">
        <Loader2 className="h-8 w-8 animate-spin text-gold" />
      </div>
    );
  if (user === false) return <Navigate to="/admin/login" replace />;

  const handleLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA]" data-testid="admin-layout">
      <header className="sticky top-0 z-40 bg-ink text-white shadow-lg">
        <div className="container-oxy flex h-14 items-center justify-between gap-3">
          <Link to="/admin" data-testid="admin-logo" className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-gold font-display text-base font-extrabold text-ink">O</span>
            <span className="font-display text-sm font-bold tracking-wide">Admin<span className="text-gold"> · Oxyservices</span></span>
          </Link>
          <div className="flex items-center gap-2">
            <Link to="/" data-testid="admin-view-site" className="inline-flex items-center gap-1.5 rounded-full border border-white/20 px-3.5 py-1.5 text-xs font-semibold text-slate-300 transition-colors hover:border-gold hover:text-gold">
              <ExternalLink className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Voir le site</span>
            </Link>
            <button onClick={handleLogout} data-testid="admin-logout-btn"
              className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3.5 py-1.5 text-xs font-semibold text-slate-300 transition-colors hover:bg-red-500/20 hover:text-red-300">
              <LogOut className="h-3.5 w-3.5" /> <span className="hidden sm:inline">Déconnexion</span>
            </button>
          </div>
        </div>
        <nav className="border-t border-white/10" data-testid="admin-tabs">
          <div className="container-oxy flex flex-wrap gap-1 py-2">
            {TABS.map((t) => {
              const Icon = t.icon;
              return (
                <NavLink key={t.to} to={t.to} end={t.end} data-testid={`admin-tab-${t.label.toLowerCase()}`}
                  className={({ isActive }) =>
                    `flex shrink-0 items-center gap-1.5 rounded-full px-3.5 py-2 text-xs font-semibold transition-colors ${isActive ? "bg-gold text-ink" : "text-slate-300 hover:bg-white/10"}`}>
                  <Icon className="h-4 w-4" /> {t.label}
                </NavLink>
              );
            })}
          </div>
        </nav>
      </header>
      <main className="container-oxy py-6 sm:py-8" style={{ paddingBottom: "calc(3rem + env(safe-area-inset-bottom))" }}>
        <Outlet />
      </main>
    </div>
  );
}
